import React from 'react';

interface StepperPlusIconProps {
    color?: string;
}

const StepperPlusIcon: React.FC<StepperPlusIconProps> = ({ color = '#004080' }) => {
    return (
        <svg width="12" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1V13" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M1 7H13" stroke={color} strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
};

export default StepperPlusIcon;
